import { GET_ACADEMIC_SESSION_LIST,
  POST_ACADEMIC_SESSION_STATUS_UPDATE,
  GET_ACADEMIC_YEAR_MASTER_LIST,
  GET_ACADEMIC_SESSION_HISTORY_LIST } from "../constants";

const initialState = {
  list: [],
  totalPage: 0,
  totalRecode: 0,
  historyList: [],
  historyTotalPage: 0,
  historyTotalRecode: 0,
  academicYear: [],
  showLoading: false,
};

export function AcademicReducer(state = initialState, action) {

  if (action.type === GET_ACADEMIC_SESSION_LIST) {
    return {
      ...state,
      list: action.payload.data,
      totalPage: action.payload.total_page,
      totalRecode: action.payload.total_record,
      showLoading: false,
    };
  }

  if (action.type === GET_ACADEMIC_SESSION_HISTORY_LIST) {
    return {
      ...state,
      historyList: action.payload.data,
      historyTotalPage: action.payload.total_page,
      historyTotalRecode: action.payload.total_record,
      showLoading: false,
    };
  }

  if (action.type === POST_ACADEMIC_SESSION_STATUS_UPDATE) {

    const list = [...state.list];
    const index = list.findIndex((item) => item.id === action.payload.id);
    list[index].status = parseInt(action.payload.status) === 1 ? 0 : 1;

    return {
        ...state,
        list: list,
        showLoading: false,
    };
}

if (action.type === GET_ACADEMIC_YEAR_MASTER_LIST) {
  return {
      ...state,
      academicYear: action.payload,
  };
}

  return state;
}
